import { api } from './client';

// Dashboard Layout API
export interface WidgetConfig {
  type: string;
  position: number;
  config?: Record<string, string>;
}

export const dashboardApi = {
  getLayout: () => api.get<{ layout: { layout: unknown } | null }>('/analytics/dashboard-layout'),
  saveLayout: (layout: WidgetConfig[]) =>
    api.put<{ message: string }>('/analytics/dashboard-layout', { layout }),
};
